module.exports = __webpack_public_path__ + "static/img/mockup.3f2dbb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20180815/mockup.png
// module id = 262
// module chunks = 1